import { useContext } from 'react';
import { SearchContext } from './Context';

const useSearchParams = () => {
  return useContext(SearchContext);
};
export default useSearchParams;
